'use strict';

import requestTpl from './reset-password-request.html';
import successTpl from './reset-password-success.html';

class ResetPasswordController {
    /* @ngInject */
    constructor($mdToast, UsersService,
                $templateCache, $state, $stateParams, LoopBackAuth) {
        Object.assign(this, {$mdToast, UsersService, $state});
        $templateCache.put('reset-password-request.html', requestTpl);
        $templateCache.put('reset-password-success.html', successTpl);
        this.template = 'reset-password-request.html';

        this.token = $stateParams.token;
        console.log(this.token);
        LoopBackAuth.setUser(this.token);
    }

    request() {
        this.updatePasswordStatus();

        if (this.form.$valid) {
            this.showSpin = true;
            this.UsersService.updatePassword({
                newPassword: this.newPassword
            }).then(() => {
                this.template = 'reset-password-success.html';
                setTimeout(() => {
                    setTimeout(()=>{ this.$state.go('login'); }, 0);
                }, 3000);
            }, err => {
                this.showSpin = false;
                let msg = 'Ocurrio un error. Por favor contacte con IRT';
                this.$mdToast.show(
                    this.$mdToast.simple()
                        .content(msg)
                        .position('top left')
                        .hideDelay(3000)
                        .parent('reset-password')
                        .toastClass('error')
                );
                console.error(err);
            });
        }
    }

    updatePasswordStatus() {
        let mustMatchValidity = !!(this.newPassword
                                   && this.newPasswordConfirmation
                                   && this.newPassword === this.newPasswordConfirmation);
        this.form.newPasswordConfirmation
            .$setValidity('mustMatch', mustMatchValidity);
    }
}

export default ResetPasswordController;
